import { 
	ShareBaseItem, 
	PhoenixTrashItem 
} from 'phoenix/domain'

export interface IDeletedItemsService {
	getDeletedItems(): ng.IPromise<PhoenixTrashItem[]>;
	restoreItem(item: PhoenixTrashItem): ng.IPromise<ShareBaseItem>;
}

/**
 * @ngdoc service
 * @name  sharebase.sbDeletedItemsService
 *
 * @description
 * A service used to retrieve user's deleted documents and folders
 *
**/
export function DeletedItemsServiceFactory(
	$http:ng.IHttpService, 
	settingsService
): IDeletedItemsService {
	return {
		/**
		* @ngdoc method
		* @name sbDeletedItemsService#getDeletedItems
		* @methodOf sharebase.sbDeletedItemsService
		* @kind function
		*
		* @description
		* Gets the deleted items for a user
		*
		* @returns {Deferred} A promise that will resolve with an
		* array of deleted items
		*
		*/
		getDeletedItems,

		/**
		 * @ngDoc method
		 * @name sbDeletedItemsService#restoreItem
		 * @methodOf sharebase.sbDeletedItemsService
		 * @kind function
		 *
		 * @description
		 * Restore a single item to its original location
		 *
		 * @param item {Object} The item to be restored. Must be an object that gets
		 * returned from the /trash API endpoint.
		 * @returns {Deferred} A promise that will resolve with the item that was restored.
		 */
		restoreItem
	};

	function getDeletedItems(): ng.IPromise<PhoenixTrashItem[]> {
		return $http.get(settingsService.serverAPIPath + '/trash/')
			.then(function (response) {
				return response.data as PhoenixTrashItem[];
			});
	}

	function restoreItem(item: PhoenixTrashItem): ng.IPromise<ShareBaseItem> {
		let url = item.Links.RestoreUri;
		return $http.patch(url, { })
			.then(function(response) {
				return response.data as ShareBaseItem;
			});
	}
}

DeletedItemsServiceFactory.$inject = [
	'$http',
	'settingsService'
];


// WEBPACK FOOTER //
// ./src/sharebase/services/deletedItemsService.ts